<template>
  <p class="textStyle">
    <strong>To Our Site Partners:</strong><br /><span class="p"
      >We appreciate you working on our clinical trials, and we want your experience with our
      technology applications to be simple and easy. Any time that’s not the case, use the
      Application dropdown below to view information on how to contact support, hours & languages
      supported, and built-in application help.<br />
      <br />
      Alternatively, you can submit a request for support or find out where to go for support via
      the <strong>Support Request for Pfizer Applications </strong> link on Pfizer Sponsor homepage
      of the Shared Investigator Platform (SIP)
      <strong>(SIP > Sponsor/CRO > Pfizer > System Links).</strong> <br />
      <br />
      If you do not have a SIP account, please reach out to your site monitor or Pfizer point of
      contact.</span
    >
  </p>
</template>
<script>
  export default {
    name: 'app-support-header',
  };
</script>
<style scoped>
  .textStyle {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.5px;
  }
</style>
